// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"9eb8b1d9","110":"5722f471","112":"f2627974","576":"acf96b5f","787":"d16d0675"}[chunkId] + ".chunk.js";
};